module.exports = __webpack_public_path__ + "img/ic_h5_bd.8841cc26.jpeg";